export const GET_EVENTS = "getEvents";
export const GET_ATTENDEES_FOR_EVENT = "getAttendeesForEvent";
export const HAS_NEXT_ATTENDEES_FOR_EVENT = "hasNextAttendeesForEvent";
export const GET_CURRENT_USER_ATTENDEE_STATUS = "getCurrentUserAttendeeStatus";
export const GET_CURRENT_EVENT = "getCurrentEvent";
export const IS_NEXT_PAGE = "isNextPage";
